export const humanizeNumber = (num) => {
  const ones = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen'
  ]
  const tens = [
    '',
    '',
    'twenty',
    'thirty',
    'forty',
    'fifty',
    'sixty',
    'seventy',
    'eighty',
    'ninety'
  ]

  const numString = num.toString()

  if (num < 0) {
    throw new Error('Negative numbers are not supported.')
  }

  if (num === 0) {
    return 'zero'
  }

  // the case of 1 - 20
  if (num < 20) {
    return ones[num]
  }

  if (numString.length === 2) {
    return tens[numString[0]] + ' ' + ones[numString[1]]
  }

  // 100 and more
  if (numString.length === 3) {
    if (numString[1] === '0' && numString[2] === '0') {
      return ones[numString[0]] + ' hundred'
    } else {
      return (
        ones[numString[0]] +
        ' hundred and ' +
        convert(+(numString[1] + numString[2]))
      )
    }
  }

  if (numString.length === 4) {
    const end = +(numString[1] + numString[2] + numString[3])
    if (end === 0) {
      return ones[numString[0]] + ' thousand'
    }
    if (end < 100) {
      return ones[numString[0]] + ' thousand and ' + convert(end)
    }
    return ones[numString[0]] + ' thousand ' + convert(end)
  }
}

export const humanizeDay = (day) => {
  const nth = function (day) {
    if (day > 3 && day < 21) {
      return 'th'
    }
    switch (day % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }
  return day + nth(day)
}

/**
 * Capitalizes the first letter of a string and ensures null safety.
 * @param {string|null|undefined} str - The string to capitalize.
 * @returns {string} - The capitalized string or an empty string if input is null/undefined.
 */
export const capitalize = (str) => {
  if (!str) { return '' } // Handle null, undefined, or empty strings
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

/**
 * Capitalizes the first letter of each word in a string (title case).
 * Ensures null safety.
 * @param {string|null|undefined} str - The string to title-case.
 * @returns {string} - The title-cased string or an empty string if input is null/undefined.
 */
export const capitalizeWords = (str) => {
  if (!str) { return '' } // Handle null, undefined, or empty strings
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

/**
 * Formats a date into a human-readable string.
 * @param {Date | string} dateInput - The date to format (can be a Date object or a string).
 * @param {string} locale - Optional. The locale to use for formatting. Defaults to 'en-US'.
 * @returns {string} - A formatted string like "Mon, Jan 15".
 */
export function humanizeDate (dateInput, locale = 'en-US') {
  // Ensure the input is a valid Date object
  const date = dateInput ? new Date(dateInput) : new Date()

  // Fallback if the input is invalid
  if (isNaN(date.getTime())) {
    console.warn('Invalid date provided to humanizeDate. Using the current date as fallback.')
    return 'Invalid Date'
  }

  // Extract formatted date parts
  const weekDay = date.toLocaleDateString(locale, { weekday: 'short' })
  const month = date.toLocaleDateString(locale, { month: 'short' })
  const day = date.toLocaleDateString(locale, { day: 'numeric' })

  // Return the formatted string
  return `${weekDay}, ${month} ${humanizeDay(day)}`
}

export default {}
